import React, { useId } from 'react'
import { Separator } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import Link from 'components/Link'
import { articleCategoryPath } from 'libs/paths'
import { Category } from 'types/data'

export const OtherCategories = () => {
  const { t } = useTranslation('@mc/next')
  const { articleCategories } = useStaticData<{
    articleCategories: Array<Category>
  }>()
  const headingId = useId()

  return (
    <aside className='d-none d-sm-block mc-mt-12' aria-labelledby={headingId}>
      <h2 id={headingId} className='mc-text-h8 mc-text--uppercase mc-mb-2'>
        {t('articlesCategories.otherCategories.title')}
      </h2>
      <Separator />
      {articleCategories.map(({ name, slug }) => (
        <Link
          className='mc-text-h8 mc-text--uppercase d-block mc-py-2'
          href={articleCategoryPath(slug)}
          key={slug}
          passHref
        >
          {name}
        </Link>
      ))}
    </aside>
  )
}
